import antdEnUS from 'antd/es/locale/en_US'
import { merge } from 'lodash'
import { Locale } from '.'
import enUS from './translations/en-US.json'

const localeValues: Locale = merge(antdEnUS, enUS)

export default localeValues
